// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1ZIWZ","label":"Completed_label__1Sdu3"};